<template>
  <div class="help-float"
       :class="isShow ? '_show' : null"
       @click="$emit('toggle-tooltip')">
    <div class="help-float__btn">?</div>
    <div :style="{transitionDuration: transitionDurationMS + 'ms'}"
         class="help-float__content">
      <div class="help-float__text-wrap">
        <span v-html="title" class="help-float__text"></span>
      </div>
    </div>
  </div>
</template>

<script>
  const transitionDurationMS = 300
  const timout = 3000

  export default {
    name: 'HelpFloat',
    props: {
      title: String
    },
    data() {
      return {
        isShow: false,
        transitionDurationMS,
        timer: null,
        timer2: null,
      }
    },
    methods: {
      show() {
        if(!this.title) return

        this.isShow = false

        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.isShow = true

          clearTimeout(this.timer2)
          this.timer2 = setTimeout(() => {
            this.isShow = false
          }, timout)
        }, transitionDurationMS * 2)
      }
    },
    created() {
      this.show()
    },
    watch: {
      title() {
        this.show()
      }
    }
  }
</script>

<style>

</style>
